import React, { useState } from "react";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import moment from "moment/moment";
import { toast } from "react-toastify";
import styles from "../customers/customerDialogs.module.scss";

const ROLE_LABELS = { clerk: "Clerk", handler: "Handler", airportStaff: "Airport Staff", driver: "Driver", admin: "Admin" };

const AddStaffDialog = ({ roles, onsuccess }) => {
    const [role, setRole] = useState(roles.length === 1 ? roles[0] : "");
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
            password: "",
            role: "",
            date: moment().format("DD-MM-YYYY"),
            verified: true,
        },

        onSubmit: async (data) => {
            if (isSubmitting) return;
            data.role = role;
            data.dateJoined = Date.now();
            if (!data?.firstName) {
                toast.error("Please enter first name");
            } else if (!data?.lastName) {
                toast.error("Please enter last name");
            } else if (!data?.email) {
                toast.error("Please enter email");
            } else if (!data?.password) {
                toast.error("Please enter password");
            } else if (!data?.phone) {
                toast.error("Please enter phone");
            } else if (!data?.role) {
                toast.error("Please select role");
            } else {
                setIsSubmitting(true);
                try {
                    const result = await dispatch(handlePostRequest(data, "/singup", true, true));
                    if (result !== "error") {
                        onsuccess();
                    }
                } finally {
                    setIsSubmitting(false);
                }
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} className={styles.dialogForm}>
            <div className={styles.fieldsGrid}>
                <div className={styles.field}>
                    <label htmlFor="firstName">First Name</label>
                    <InputText id="firstName" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="lastName">Last Name</label>
                    <InputText id="lastName" name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="email">Email Address</label>
                    <InputText id="email" name="email" value={formik.values.email} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="password">Password</label>
                    <InputText id="password" name="password" value={formik.values.password} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="phone">Phone Number</label>
                    <InputText id="phone" name="phone" value={formik.values.phone} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="role">Role</label>
                    {roles.length === 1 ? (
                        <InputText disabled value={ROLE_LABELS[roles[0]] || roles[0]} />
                    ) : (
                        <select id="role" value={role} onChange={(e) => setRole(e.target.value)}>
                            <option disabled value="">
                                Select Role
                            </option>
                            {roles.map((r) => (
                                <option key={r} value={r}>
                                    {ROLE_LABELS[r] || r}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            </div>

            <div className={styles.actions}>
                <Button label={isSubmitting ? "Creating..." : "Create"} className={styles.submitButton} disabled={isSubmitting} icon={isSubmitting ? "pi pi-spin pi-spinner" : ""} />
            </div>
        </form>
    );
};

export default AddStaffDialog;
